export default "__VITE_ASSET__$0ZUg9Is__"